import React from 'react';
import { AuthProvider } from 'features/auth/AuthProvider';
import App from 'app/App';

const RootPage = () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);

export default RootPage;
